<div *ngIf="show" class="loader-content">
  <div class="loader-section">
    <div class="col-sm-12 text-center">
      <img
        class="mt-10"
        width="70"
        height="70"
        src="../../../assets/images/loadingold.gif"
        alt="Loader Image"
      />
    </div>
  </div>
</div>
